export enum CustomerDetailTabs {
    Overview = 'overview',
    Addresses = 'addresses',
    Employee = 'employee',
    Documents = 'documents',
    Conditions = 'conditions',
    Topics = 'topics',
    Transactions = 'transactions',
    ExternalCustomerMapping = 'external-customer-mapping',
}
